export default "__VITE_ASSET__NPIJ5ENZ__"